import {
	mountVideoPlayer,
	parseVideoUrl,
} from '../utils/parse-video-url.js';

const mountStagePlayer = (mediaEl, parsed) => {
	mountVideoPlayer(mediaEl, parsed);

	const video = mediaEl.querySelector('video');
	const iframe = mediaEl.querySelector('iframe');

	if (video) {
		video.className = 'video-section__video';
	}

	if (iframe) {
		iframe.className = 'video-section__iframe';
	}
};

const stopStage = (stage, mediaEl, playBtn) => {
	const video = mediaEl.querySelector('video');
	if (video) {
		video.pause();
	}

	mediaEl.replaceChildren();
	mediaEl.hidden = true;
	stage.classList.remove('is-playing');
	stage.style.removeProperty('--video-aspect');
	playBtn.setAttribute('aria-label', 'Video abspielen');
	playBtn.setAttribute('aria-pressed', 'false');
};

const startStage = (stage, mediaEl, playBtn, parsed) => {
	mountStagePlayer(mediaEl, parsed);
	stage.classList.add('is-playing');
	stage.removeAttribute('role');
	stage.removeAttribute('aria-label');
	mediaEl.hidden = false;
	playBtn.setAttribute('aria-label', 'Video stoppen');
	playBtn.setAttribute('aria-pressed', 'true');

	const video = mediaEl.querySelector('video');
	if (!video) {
		return;
	}

	// The stage sizes itself to the film while playing so nothing is cropped
	// (issue #171); embeds keep the 16/9 fallback in the stylesheet.
	video.addEventListener(
		'loadedmetadata',
		() => {
			if (video.videoWidth && video.videoHeight) {
				stage.style.setProperty(
					'--video-aspect',
					`${video.videoWidth} / ${video.videoHeight}`,
				);
			}
		},
		{ once: true },
	);

	// Only `ended` unmounts the player. `pause` also fires while the user drags
	// the native timeline, which tore the <video> down and snapped the stage back
	// to the poster mid-watch (issue #170).
	video.addEventListener(
		'ended',
		() => {
			stopStage(stage, mediaEl, playBtn);
		},
		{ once: true },
	);
};

const resolveStageSource = (stage) => {
	const fileSrc = stage.dataset.videoFile?.trim();
	if (fileSrc) {
		return { type: 'file', src: fileSrc };
	}

	return parseVideoUrl(stage.dataset.videoUrl?.trim());
};

const bindStage = (stage) => {
	const parsed = resolveStageSource(stage);
	const playBtn =
		stage.querySelector('.js-video-section-play') ?? stage.querySelector('.js-process-play');
	const mediaEl =
		stage.querySelector('.js-video-section-media') ?? stage.querySelector('.js-process-media');

	if (!parsed || !playBtn || !mediaEl) {
		return;
	}

	playBtn.addEventListener('click', (event) => {
		event.preventDefault();
		event.stopPropagation();

		if (stage.classList.contains('is-playing')) {
			stopStage(stage, mediaEl, playBtn);
			return;
		}

		startStage(stage, mediaEl, playBtn, parsed);
	});
};

export const initVideoSectionPlayer = () => {
	document
		.querySelectorAll('.js-video-section-stage, .js-process-stage')
		.forEach(bindStage);
};
